<div class="set-pwd-failure__main-container">
  <div
    [ngClass]="{
      'set-pwd-failure__main__img-bloc--myvetreco': env.isWhiteLabelMyVetReco,
    }"
    class="set-pwd-failure__main-container__img-container"
  >
    <img
      role="presentation"
      alt=""
      src="./assets/images/reset_password_error.jpg"
    />
  </div>
  <div class="set-pwd-failure__main-container__text-container">
    <h1 class="set-pwd-failure__main-container__text-container__h1">
      {{ 'setPasswordFailure_title' | translate }}
    </h1>

    <p class="set-pwd-failure__main-container__text-container__content-p">
      @if (hideSupportBt) {
        {{ 'reset_phoneValidationCodeError' | translate }}
      } @else {
        {{ 'setPasswordFailure_content' | translate }}
      }
    </p>

    <div class="set-pwd-failure__main-container__text-container__bottom">
      <button
        (click)="retryReset()"
        class="rc-button rc-button--outline-regular set-pwd-failure__main-container__text-container__bottom__button1"
      >
        <span class="rc-button__title">{{
          'setPasswordFailure_buttonTryAgain' | translate
        }}</span>
      </button>
      @if (!hideSupportBt) {
        <button
          class="rc-button rc-button--outline-regular set-pwd-failure__main-container__text-container__bottom__button2"
        >
          <app-contact-us-button
            labelKey="setPasswordFailure_buttonSupport"
          ></app-contact-us-button>
        </button>
      }
    </div>
  </div>
</div>
